export type FeedPostCtaType = 'connect' | 'connectieflow' | 'signup' | 'website' | 'custom';

export interface FeedPostCTA {
  enabled: boolean;
  type: FeedPostCtaType;
  label: string;
  href?: string;
  target?: '_self' | '_blank';
  visibilityScope?: 'all' | 'region';
  visibilityRegions?: string[];
  source?: 'default' | 'author';
  updatedAt?: Date;
  updatedBy?: string;
}

export interface ScreenLockState {
  xItems: number;
  baseXItems: number;
  itemsSinceLastLock: number;
  locksThisSession: number;
  lastLockAtMs: number;
  cooldownUntilMs: number;
  engagementIndex: number;
  fastSkipStreak: number;
  device: 'desktop' | 'mobile';
}

export type ScreenLockOutcome = 'continue' | 'scroll' | 'dismiss_after_timer';

export interface ScreenLockAnalyticsEvent {
  userId: string;
  outcome: ScreenLockOutcome;
  device: 'desktop' | 'mobile';
  relevanceScore: number;
  xItemsAtTrigger: number;
  createdAtMs: number;
}

export interface ReplyIntroductionPayload {
  source: 'post_reply';
  postId: string;
  commentId?: string;
  fromUserId: string;
  toUserId: string;
  recommendedUserId: string;
  message?: string;
}

export const DEFAULT_CONNECTIEFLOW_CTA: FeedPostCTA = {
  enabled: true,
  type: 'connectieflow',
  label: 'Open ConnectieFlow',
  target: '_self',
  visibilityScope: 'all',
  source: 'default',
};
